import { render, staticRenderFns } from "./projectScoringSumIndex.vue?vue&type=template&id=2aa5e7e3&scoped=true"
import script from "./projectScoringSumIndex.vue?vue&type=script&lang=js"
export * from "./projectScoringSumIndex.vue?vue&type=script&lang=js"
import style0 from "./projectScoringSumIndex.vue?vue&type=style&index=0&id=2aa5e7e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa5e7e3",
  null
  
)

export default component.exports